import React from 'react';
import {
  COLORS,
  SPACING,
  FONT_SIZE,
  FONT_WEIGHT,
  BORDER_RADIUS,
  SHADOWS,
} from '../../constants/theme';
import { formatDate, formatStatType } from '../../utils/formatters';

/**
 * StatCard Component
 * Mobile-optimized card for displaying player statistics
 *
 * @param {Object} stat - The player stat object
 */
const StatCard = ({ stat }) => {
  const styles = {
    card: {
      backgroundColor: COLORS.white,
      borderRadius: BORDER_RADIUS.md,
      boxShadow: SHADOWS.md,
      padding: SPACING.lg,
      marginBottom: SPACING.md,
      border: `1px solid ${COLORS.gray[300]}`,
      width: '100%',
      boxSizing: 'border-box',
      overflow: 'hidden',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: SPACING.md,
      paddingBottom: SPACING.md,
      borderBottom: `1px solid ${COLORS.gray[200]}`,
    },
    title: {
      fontSize: FONT_SIZE.lg,
      fontWeight: FONT_WEIGHT.semibold,
      color: COLORS.gray[700],
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: SPACING.sm,
      marginBottom: SPACING.md,
      fontSize: FONT_SIZE.base,
    },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      gap: SPACING.xs,
    },
    label: {
      fontWeight: FONT_WEIGHT.semibold,
      color: COLORS.gray[600],
      fontSize: FONT_SIZE.md,
    },
    value: {
      color: COLORS.gray[700],
      fontSize: FONT_SIZE.md,
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
    },
  };

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <div style={styles.title}>{stat.category?.name || formatStatType(stat.stat_type)}</div>
      </div>
      <div style={styles.body}>
        <div style={styles.row}>
          <div>
            <div style={styles.label}>Value</div>
            <div style={styles.value}>
              {stat.value} {stat.unit}
            </div>
          </div>
          <div>
            <div style={styles.label}>Date</div>
            <div style={styles.value}>{formatDate(stat.recorded_date)}</div>
          </div>
        </div>
        {stat.rank && (
          <div style={styles.row}>
            <div>
              <div style={styles.label}>Team Rank</div>
              <div style={styles.value}>
                <span style={{ fontWeight: '600' }}>
                  #{stat.rank.stat_rank} of {stat.rank.total_stats}
                </span>
              </div>
            </div>
          </div>
        )}
        {stat.notes && (
          <div>
            <div style={styles.label}>Notes</div>
            <div style={styles.value}>{stat.notes}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
